import { partfinitiClient } from './partfinitiClient';

export const getColorsTheme = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/common/custom-config/colors', signal);

  return data.colors;
};

export const getFontsTheme = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/common/custom-config/fonts', signal);

  return data.fonts;
};

export const getFontFamiliesTheme = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/common/custom-config/font-families', signal);

  return data.font_families;
};
